import { render } from "./Dialogue.vue?vue&type=template&id=11bbf4c6&scoped=true"
import script from "./Dialogue.vue?vue&type=script&lang=js"
export * from "./Dialogue.vue?vue&type=script&lang=js"

import "./Dialogue.vue?vue&type=style&index=0&id=11bbf4c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bbf4c6"]])

export default __exports__